export default __webpack_public_path__ + "/dist/images/image00024.40a5d10e8b1965f4697a152f81e15ca5.jpg";